import React, { useEffect, useState } from "react";
import "../css/home.less";
import { getImageUrl } from "../config";
import QueueAnim from "rc-queue-anim";
import { Button } from "antd";
import RcScrollOverPack from "rc-scroll-anim/lib/ScrollOverPack";
import LocalizedLink from "../components/LocalizedLink";
import { useTranslation } from "react-i18next";
import { fetchLocalizedJson } from "../api/fetchLocalizedJson";

const SubHome2: React.FC = () => {

    const { t, i18n } = useTranslation();
    const [caseData, setCaseData] = useState<Record<string, string>>({});

    useEffect(() => {
        fetchLocalizedJson<{ id: string; title: string }[]>("development_cases.json")
            .then((data) => {
                const map: Record<string, string> = {};
                data.forEach((item) => {
                    map[item.id] = item.title.replace(/\n/g, "<br className='sp' />");
                });
                setCaseData(map);
            })
            .catch((err) => console.error("Error fetching cases for top page:", err));
    }, [i18n.language]);

    const caseItems = [
        {
            key: "1",
            image: "/image/top-case01.png",
            title: caseData["01"] || "クラウド経費精算<br className='sp' />システム",
        },
        {
            key: "2",
            image: "/image/top-case02.png",
            title: caseData["02"] || "大手専門技術商社の各システム<br className='sp' />データの集約・統合・連携",
        },
        {
            key: "3",
            image: "/image/top-case03.png",
            title: caseData["03"] || "洋上風力発電レイアウト<br className='sp' />最適化プラットフォーム",
        },
        {
            key: "4",
            image: "/image/top-case04.png",
            title: caseData["04"] || "給料計算パッケージ構築",
        },
    ];

    return (
        <RcScrollOverPack id="top-case-studies" className="homepage case-studies">
            <QueueAnim
                duration={450}
                type="bottom"
                className="case-studies__anim"
                key="case-studies-header"
                leaveReverse
            >
                <h2 key="h2" className="home-title-ja case-studies__title-ja">
                    {t("home.cases_title")}
                </h2>
                <p key="en" className="home-title-en case-studies__title-en">
                    Case studies
                </p>
            </QueueAnim>

            <QueueAnim
                duration={450}
                type="bottom"
                className="case-studies__grid-anim"
                key="case-studies-grid"
                leaveReverse
            >
                <div key="grid" className="case-studies__grid-scroll">
                    <div className="case-studies__grid">
                        {caseItems.map((item) => (
                            <div key={item.key} className="case-studies__card">
                                <div className="case-studies__card-image-wrap">
                                    <img
                                        src={getImageUrl(item.image)}
                                        alt=""
                                        className="case-studies__card-image"
                                    />
                                </div>
                                <p className="case-studies__card-title" dangerouslySetInnerHTML={{ __html: item.title }} />
                                <LocalizedLink to="/development" className="case-studies__card-link">
                                    <Button
                                        type="primary"
                                        className="case-studies__card-btn"
                                    >
                                        {t("home.more_details")}
                                    </Button>
                                </LocalizedLink>
                            </div>
                        ))}
                    </div>
                </div>
            </QueueAnim>
            <QueueAnim
                duration={450}
                type="bottom"
                className="case-studies__cta-anim"
                key="case-studies-cta"
                leaveReverse
            >
                <div key="cta" className="case-studies__cta-row">
                    <LocalizedLink to="/development">
                        <Button
                            type="primary"
                            size="large"
                            className="case-studies__cta-main"
                        >
                            {t("service_page.view_achievements")}
                        </Button>
                    </LocalizedLink>
                    <LocalizedLink to="/scientific_career">
                        <Button
                            type="primary"
                            size="large"
                            className="case-studies__cta-main"
                        >
                            {t("nav.scientific_career")}
                        </Button>
                    </LocalizedLink>
                </div>
            </QueueAnim>
        </RcScrollOverPack>
    );
};

export default SubHome2;
